// Definimos aqui funciones para que el frontend pueda llamar a los endpoints del backend.
import axios from 'axios';

import {
  AdminApiFactory,
  AlarmApiFactory,
  DevicesApiFactory,
  IngestionApiFactory,
  MyAccountApiFactory,
  PatientsApiFactory,
  SessionsApiFactory,
  UsersApiFactory,
  IncidenceApiFactory,
  DashboardsApiFactory,
  AuthApiFactory,
  AuthPublicApiFactory,
  MaintenanceOrdersApiFactory,
  OTAFirmwareManagementApiFactory,
  SurveyApiFactory,
  VideosApiFactory
} from '../typescript-axios/api';

export const apiServices = {
  adminApi: AdminApiFactory(),
  alarmApi: AlarmApiFactory(),
  devicesApi: DevicesApiFactory(),
  ingestionApi: IngestionApiFactory(),
  myAccountApi: MyAccountApiFactory(),
  patientApi: PatientsApiFactory(),
  sessionApi: SessionsApiFactory(),
  userApi: UsersApiFactory(),
  authApi: AuthApiFactory(),
  authPublicApi: AuthPublicApiFactory(),
  incidenceApi: IncidenceApiFactory(),
  surveyApi: SurveyApiFactory(),
  dashboardsApi: DashboardsApiFactory(),
  otaApi: OTAFirmwareManagementApiFactory(),
  videosApi: VideosApiFactory(),
  maintenanceOrderApi: MaintenanceOrdersApiFactory()
};
